import { TransferAPIType } from '@wetransfer/transfer/apollo-api/usage/types';
import { State } from '@wetransfer/transfer/store/types';
import TransferItem from '@wetransfer/transfer/transfer-bundle/models/transfer-item';
import { NormalizedTransfer } from '@wetransfer/transfer/transfer-bundle/types/transfers';

const sumItemsSizes = (items: { size?: number }[]): number =>
  items
    .map(({ size = 0 }) => size)
    .reduce((total, size): number => total + size, 0);

export const getTotalFileSize = (
  transfer: State['transfer'] | NormalizedTransfer | TransferAPIType
): number => {
  if ('size' in transfer && transfer.size) {
    return transfer.size;
  }

  if ('files' in transfer && transfer.files.length) {
    return sumItemsSizes(transfer.files);
  }

  if ('items' in transfer && transfer.items.length) {
    return sumItemsSizes(transfer.items);
  }

  return 0;
};

export const getTransferNumberOfFiles = (
  transfer: State['transfer'] | NormalizedTransfer | TransferAPIType
): number => {
  if ('files' in transfer && transfer.files.length) {
    return transfer.files.length;
  }

  if ('items' in transfer && transfer.items.length) {
    return transfer.items.length;
  }

  return 0;
};

export const getTransferFileById = (
  transfer: State['transfer'] | NormalizedTransfer | TransferAPIType,
  fileId: string
): TransferItem | undefined => {
  if ('files' in transfer && transfer.files.length) {
    return transfer.files.find((file) => file.id === fileId);
  }

  if ('items' in transfer && transfer.items.length) {
    return transfer.items.find((file) => file.id === fileId);
  }

  return undefined;
};
